import { lazy } from 'react';

export const PlayerUpdateCustomerWhiteListStatusForm = lazy(
  () => import('./PlayerUpdateCustomerWhiteListStatusForm'),
);
